import React, { useState } from 'react';
import { useAppSelector } from '@/store/hooks'; // Add
import { selectUser, selectUserProfile, selectAuthLoading } from '@/store/slices/authSlice'; // Add
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import ProfileSheet from './ProfileSheet';

interface UserBoxProps {
  variant?: 'default' | 'compact'; // compact for sidebar, default for opening page
}

const UserBox: React.FC<UserBoxProps> = ({ variant = 'default' }) => {
  // const { currentUser, userProfile, loading } = useAuth(); // Remove
  const currentUser = useAppSelector(selectUser); // Add
  const userProfile = useAppSelector(selectUserProfile); // Add
  const authLoading = useAppSelector(selectAuthLoading); // Get the loading state once
  const loading = authLoading === 'pending' || authLoading === 'initializing'; // Then check the value
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  
  // const handleLogout = async (e: React.MouseEvent) => { // Remove handleLogout
  //   e.stopPropagation();
  //   try {
  //     await signOut(auth);
  //     console.log('User signed out successfully');
  //   } catch (error) {
  //     console.error('Error signing out:', error);
  //   }
  // };

  // Don't render anything if still loading or no user
  if (loading || !currentUser) return null;

  // Generate initials for avatar fallback
  const getInitials = () => {
    if (userProfile?.username) {
      return userProfile.username.slice(0, 2).toUpperCase();
    } else if (currentUser.displayName) {
      // Simpler approach to avoid type issues
      const parts = currentUser.displayName.split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      } else if (parts[0]) {
        return parts[0][0].toUpperCase();
      }
    } else if (currentUser.email) {
      return currentUser.email[0].toUpperCase();
    }
    return '?';
  };

  // Get display name, prioritizing username
  const displayName = userProfile?.username || currentUser.email?.split('@')[0] || 'User';

  return (
    <>
      <div 
        className={`
          flex items-center ${variant === 'compact' ? 'w-full' : 'w-56'} 
          gap-3 p-2 rounded-md text-left
          cursor-pointer
        `}
        onClick={() => setIsProfileOpen(true)}
      >
        <Avatar className="h-12 w-12 border border-primary/10">
          <AvatarImage src={currentUser.photoURL || undefined} alt={displayName} />
          <AvatarFallback>{getInitials()}</AvatarFallback>
        </Avatar>
        
      </div>

      <ProfileSheet 
        isOpen={isProfileOpen} 
        onClose={() => setIsProfileOpen(false)} 
        side="right"
      />
    </>
  );
};

export default UserBox;  